<template>
  <div
    :class="['plan-card position-relative pt-sm', { selected, selectable }]"
    @click="onClick">
    <h6 class="tag-line text-nowrap position-absolute m-0 px-xs">
      {{ tagLine || plan?.tagLine }}
      <template v-if="$slots.tagLine">
        <slot name="tagLine"/>
      </template>
    </h6>
    <PlanCardDescription
      v-bind="$attrs"
      :plan-id="planId"
      :price-line="priceLine">
      <template
        v-if="$slots.displayName"
        #displayName>
        <slot name="displayName"/>
      </template>
      <template
        v-if="$slots.details"
        #details>
        <slot name="details"/>
      </template>
      <template
        v-if="$slots.footer"
        #footer>
        <slot name="footer"/>
      </template>
    </PlanCardDescription>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useSubscriptionStore } from '@/stores/subscribe.js'
import { storeToRefs } from 'pinia'
import { usePlans } from '@shared/composables/plans.js'
import PlanCardDescription from './PlanCardDescription.vue'

const props = defineProps({
  planId: {
    type: String,
    required: true
  },
  selectable: {
    type: Boolean,
    default: true
  },
  forceSelected: {
    type: Boolean,
    default: false
  },
  priceLine: {
    type: String,
    default: null
  },
  tagLine: {
    type: String,
    default: null
  }
})


const subscriptionStore = useSubscriptionStore()
const { selectedPlanId } = storeToRefs(subscriptionStore)
const { selectMembershipPlan } = subscriptionStore
const { planById } = usePlans()

const selected = computed(() => 
  props.forceSelected || props.planId === selectedPlanId.value)

const plan = computed(() => planById(props.planId))

const emits = defineEmits(['selected'])
async function onClick () {
  if (props.selectable) {
    selectMembershipPlan({ planId: props.planId, trackEvent: true })
    emits('selected', props.planId)
  }
}
</script>

<style scoped lang="scss">
.plan-card {
  --plan-card-min-width: 246px;
  min-width: var(--plan-card-min-width);
  user-select: none;

  .tag-line {
    border-radius: $sequin-border-radius;
    background-color: $pewter;
    color: $white;
    top: 1px;
    width: fit-content;
    left: 50%;
    transform: translateX(-50%);
    padding-top: 1px;
    padding-bottom: 1px;
  }

  &.selected {
    min-width: 305px;
    .tag-line {
      background-color: $orchid;
      top: 3px;
    }
    :deep(.details) {
      border: 4px solid $orchid;
    }
  }

  &.selectable {
    cursor: pointer;
  }
}
</style>